// Wishlist functionality
(function () {
  if (window.shopifyWishlist) return; // already initialized, avoid re-declaration

  class Wishlist {
    constructor() {
      this.storageKey = 'shopify_wishlist';
      this.handleMapKey = 'shopify_wishlist_handles';
      this.wishlist = this.getWishlist();
      this.init();
    }

    init() {
      // 위시리스트 버튼 이벤트 리스너 추가
      document.addEventListener('click', (e) => {
        if (e.target.closest('.wishlist-btn')) {
          e.preventDefault();
          const button = e.target.closest('.wishlist-btn');
          const productId = button.getAttribute('data-product-id');
          const productHandle = button.getAttribute('data-product-handle');
          if (productId && productHandle) {
            this.setHandleForId(productId, productHandle);
          }
          this.toggleWishlist(productId, button);
        }
      });

      // 페이지 로드 시 위시리스트 상태 업데이트
      this.updateWishlistButtons();
    }

    getWishlist() {
      try {
        const stored = localStorage.getItem(this.storageKey);
        return stored ? JSON.parse(stored) : [];
      } catch (error) {
        console.error('Error loading wishlist:', error);
        return [];
      }
    }

    saveWishlist() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(this.wishlist));
        // 위시리스트 변경 이벤트 발생
        window.dispatchEvent(
          new CustomEvent('wishlistChanged', {
            detail: { wishlist: this.wishlist },
          })
        );
      } catch (error) {
        console.error('Error saving wishlist:', error);
      }
    }

    isInWishlist(productId) {
      return this.wishlist.includes(String(productId));
    }

    getHandleMap() {
      try {
        const stored = localStorage.getItem(this.handleMapKey);
        return stored ? JSON.parse(stored) : {};
      } catch {
        return {};
      }
    }

    setHandleForId(productId, handle) {
      try {
        const map = this.getHandleMap();
        map[String(productId)] = handle;
        localStorage.setItem(this.handleMapKey, JSON.stringify(map));
      } catch {}
    }

    addToWishlist(productId) {
      const id = String(productId);
      if (!this.isInWishlist(id)) {
        this.wishlist.push(id);
        this.saveWishlist();
        return true;
      }
      return false;
    }

    removeFromWishlist(productId) {
      const id = String(productId);
      const index = this.wishlist.indexOf(id);
      if (index > -1) {
        this.wishlist.splice(index, 1);
        this.saveWishlist();
        return true;
      }
      return false;
    }

    toggleWishlist(productId, button) {
      const id = String(productId);
      let message = '';
      let isSuccess = true;

      if (this.isInWishlist(id)) {
        if (this.removeFromWishlist(id)) {
          message = '위시리스트에서 제거되었습니다';
          button.classList.remove('active');
          button.setAttribute('aria-label', '위시리스트에 추가');
        } else {
          message = '위시리스트에서 제거에 실패했습니다';
          isSuccess = false;
        }
      } else {
        if (this.addToWishlist(id)) {
          message = '위시리스트에 추가되었습니다';
          button.classList.add('active');
          button.setAttribute('aria-label', '위시리스트에서 제거');
        } else {
          message = '위시리스트 추가에 실패했습니다';
          isSuccess = false;
        }
      }

      this.showToast(message, isSuccess);

      // 앱 프록시로 동기화 (고객이 로그인된 경우에만)
      try {
        const customerId = window.__CUSTOMER_ID__;
        if (customerId) {
          const act = this.isInWishlist(id) ? 'add' : 'remove';
          const map = this.getHandleMap();
          const handle = map[id] || null;
          fetch('/apps/tupperwish/wishlist', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customerId, productId: id, action: act, handle }),
            credentials: 'same-origin',
          })
            .then(async (r) => {
              const text = await r.text();
              let data = null;
              try {
                data = JSON.parse(text);
              } catch (e) {
                /* non-JSON (HTML error, etc.) */
              }
              if (!r.ok) {
                console.warn('Wishlist sync failed:', r.status, text?.slice?.(0, 300));
                return;
              }
              if (!data || !data.ok) {
                console.warn('Wishlist sync failed:', (data && data.error) || text?.slice?.(0, 300));
              }
            })
            .catch((err) => console.warn('Wishlist sync error:', err));
        }
      } catch (e) {
        console.warn('Wishlist sync skipped:', e);
      }
    }

    updateWishlistButtons() {
      const buttons = document.querySelectorAll('.wishlist-btn');
      buttons.forEach((button) => {
        const productId = button.getAttribute('data-product-id');
        if (this.isInWishlist(productId)) {
          button.classList.add('active');
          button.setAttribute('aria-label', '위시리스트에서 제거');
        } else {
          button.classList.remove('active');
          button.setAttribute('aria-label', '위시리스트에 추가');
        }
      });
    }

    showToast(message, isSuccess = true) {
      // 기존 토스트 제거
      const existingToast = document.querySelector('.wishlist-toast');
      if (existingToast) {
        existingToast.remove();
      }

      // 새 토스트 생성
      const toast = document.createElement('div');
      toast.className = `wishlist-toast ${isSuccess ? 'success' : 'error'}`;
      toast.textContent = message;

      // DOM에 추가
      document.body.appendChild(toast);

      // 애니메이션을 위한 지연
      setTimeout(() => {
        toast.classList.add('show');
      }, 10);

      // 3초 후 제거
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => {
          if (toast.parentNode) {
            toast.remove();
          }
        }, 300);
      }, 3000);
    }

    getWishlistCount() {
      return this.wishlist.length;
    }

    getWishlistItems() {
      return [...this.wishlist];
    }

    clearWishlist() {
      this.wishlist = [];
      this.saveWishlist();
      this.updateWishlistButtons();
    }
  }

  // 전역 Wishlist 인스턴스 생성
  window.shopifyWishlist = new Wishlist();

  // 페이지 로드 완료 후 추가 초기화
  document.addEventListener('DOMContentLoaded', function () {
    // 위시리스트 상태 재확인
    window.shopifyWishlist.updateWishlistButtons();
  });

  // Shopify 테마 개발자를 위한 유틸리티 함수들
  window.WishlistUtils = {
    // 특정 상품이 위시리스트에 있는지 확인
    isInWishlist: (productId) => window.shopifyWishlist.isInWishlist(productId),

    // 위시리스트에 상품 추가
    addToWishlist: (productId) => window.shopifyWishlist.addToWishlist(productId),

    // 위시리스트에서 상품 제거
    removeFromWishlist: (productId) => window.shopifyWishlist.removeFromWishlist(productId),

    // 위시리스트 아이템 수 가져오기
    getCount: () => window.shopifyWishlist.getWishlistCount(),

    // 위시리스트 전체 아이템 가져오기
    getItems: () => window.shopifyWishlist.getWishlistItems(),

    // 위시리스트 비우기
    clear: () => window.shopifyWishlist.clearWishlist(),
  };
})();
